<!-- 全部客户 -->
<template>
  <div>
    <div class="head-title">全部客户</div>
    <nav class="navbar">
      <div class="nav-l">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          :loading="updateLoading"
          @click="getRenew"
          >更新客户</el-button
        >
      </div>
      <div class="nav-r">
        <el-input
          clearable
          style="width: 22.0rem; margin: 0 2.0rem 0 2.0rem"
          placeholder="请输入姓名/电话"
          prefix-icon="el-icon-search"
          v-model="q"
          @change="getList()"
        >
        </el-input>
        <el-button slot="append" type="primary" @click="getList()"
          >查询</el-button
        >
      </div>
    </nav>
    <div class="main">
      <el-table
        :data="tableData"
        border
        header-align="center"
        align="center"
        
      >
        <el-table-column prop="title" label="客户信息" min-width="320">
          <template slot-scope="scope">
            <div class="scope-title">
              <el-image
                class="scope-title-img"
                style="width: 36px; height: 36px"
                :src="scope.row.headUrl"
                :preview-src-list="[scope.row.headUrl]"
              ></el-image>
              <div class="scope-title-text" :title="scope.row.nickName">
                <p
                  v-if="scope.row.nickName && scope.row.nickName !== '暂未授权'"
                  class="scope-title-text-row"
                >
                  {{ scope.row.nickName }}
                </p>
                <p v-else class="scope-title-text-row">
                  编号：{{ scope.row.wid }}
                </p>
                <p v-if="scope.row.phone" class="scope-title-text-row">
                  {{ scope.row.phone }}
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别">
          <template slot-scope="scope">
            <div v-if="scope.row.sex == 1">男</div>
            <div v-else-if="scope.row.sex == 2">女</div>
            <div v-else>未知</div>
          </template>
        </el-table-column>
        <el-table-column prop="gmtCreate" label="成为客户时间" width="160">
        </el-table-column>
        <el-table-column prop="currentAmount" label="余额" width="150">
          <template slot-scope="scope">
            ¥{{ scope.row.currentAmount / 100 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="currentPoint"
          label="当前积分"
          width="150"
        ></el-table-column>
        <!-- <el-table-column prop="availableDepositAmount" label="可用实充余额">
          <template slot-scope="scope">
            ¥{{ scope.row.availableDepositAmount / 100 }}
          </template>
        </el-table-column>
        <el-table-column prop="availableGiveAmount" label="可用赠送余额">
          <template slot-scope="scope">
            ¥{{ scope.row.availableDepositAmount / 100 }}
          </template>
        </el-table-column> -->
        <el-table-column prop="status" label="会员状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 1">正常</div>
            <div v-else-if="scope.row.status == 2">冻结</div>
            <div v-else-if="scope.row.status == 3">未领取</div>
            <div v-else-if="scope.row.status == 5">过期</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "./mixins/wm.js";
export default {
  name: "goodsList",
  components: {},
  mixins: [auth],
  data() {
    return {
      q: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      updateLoading: false,
    };
  },

  computed: {},
  beforeRouteLeave(to,from,next){
    let arr = ['storelist','selfList','goodsList','orderlist','customerlist']
    if(!arr.includes(to.name)){
      this.$store.state.enterWeimeng=false
    }
    next()
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getRenew() {
      this.updateLoading = true;
      // 拉取更新历史朋友圈数据
      // const { data: res } = await this.axios({
      //   url: "weimob/mc/Member/getMemberList",
      //   method: "POST",
      //   data: this.qs.stringify({
      //     phone: this.tooken.phone,
      //     usertoken: this.tooken.usertoken,
      //     account_id: this.tooken.account_id,
      //   }),
      // });
        // 拉取更新数据
      const ws = new WebSocket("wss://api.weijub.com:4431");
      ws.onopen = () => {
        console.log("连接成功");
       
        ws.send(
          JSON.stringify({
            uid: this.tooken.account_id,
            type: "getMemberList22",
            phone: this.tooken.phone,
           usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          })
        );
      };
      ws.onmessage = (e) => {
        // console.log("收到服务端的消息：" + JSON.stringify(e.data));
        // this.updateLoading = false;
        // this.loadingText = "同步客户";
        // this.$message.success("同步成功");
        // this.tableData.data = [];
        // this.userTable();
         this.updateLoading = false;
      this.tableData = [];
      this.getList();
      };
      // this.updateLoading = false;
      // this.tableData = [];
      // this.getList();
    },
    async getList() {
      const { data: res } = await this.axios({
        url: "weimob/mc/Member/returnGetMemberList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          page: this.listQuery.page,
          number_page: this.listQuery.limit,
          name: this.q,
        }),
      });
      console.log(res);
      if (res.code == 1) {
        this.tableData = res.data.data;
        this.total = res.count;
      }
    },
    onRead() {},
  },
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 3.0rem;
}
.scope-title {
  display: flex;
  font-size: 14px;
  color: #595961;
  &-img {
    width: 36px;
  }
  &-text {
    flex: 1;
    margin-left: .8rem;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    cursor: pointer;
  }
}

.sales-status {
  display: flex;
  align-items: center;
}
</style>
